const { REACT_APP_ROOT_API, REACT_APP_CARRIERAPPSHUB_API_URL, REACT_APP_WEBSOCKET_URL } = process.env

const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'

export const uiUrl =
    window.location.hostname === 'localhost'
        ? 'https://dev.pricemanagement.hvac-engineering.eu'
        : window.location.origin

export const apiUrl = isLocal ? `http://localhost:8080` : `${window.location.origin}${REACT_APP_ROOT_API}`

const defaultWsUrl = isLocal ? 'ws://localhost:8080' : `wss://${window.location.host}`

export const wsUrl = REACT_APP_WEBSOCKET_URL || defaultWsUrl

export const carrierAppsHubApiUrl = REACT_APP_CARRIERAPPSHUB_API_URL

export const appConfig = {
    uiUrl,
}
export default appConfig
